"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecyclePopover = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const AbstractHelpPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/AbstractHelpPopover");
const LifecyclePopover = () => {
    const content = React.createElement("div", { style: { width: "500px" } },
        React.createElement("p", null, "Lifecycle is an overview of your Active users."),
        React.createElement("p", null, "It breaks them down based on their activity."),
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement("b", null, "New users"),
                " are those seen for the 1st time in the current period."),
            React.createElement("li", null,
                React.createElement("b", null, "Current"),
                " are those who are active in the current period and also were active in the previous period."),
            React.createElement("li", null,
                React.createElement("b", null, "Resurrected"),
                " users are those who are active in the current period, but weren\u2019t active in the previous period."),
            React.createElement("li", null,
                React.createElement("b", null, "Churned"),
                " users are those who were active in the previous period, but aren\u2019t active in the current period."),
            React.createElement("li", null,
                React.createElement("b", null, "Quick Ratio"),
                " shows the ",
                React.createElement(antd_1.Typography.Text, { code: true }, "(new+resurrected)/churned"),
                " ratio and showing if you are growing faster than you are loosing users (Quick\u00A0Ratio should be above 1 if you\u2019re growing).")));
    return React.createElement(AbstractHelpPopover_1.AbstractHelpPopover, { title: "Lifecycle", content: content });
};
exports.LifecyclePopover = LifecyclePopover;
